import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

const AUTH_ME_KEY = 'auth_me';
const COOKIE_EXPIRES_DAYS = 7;

interface AuthState {
    me: null | {
        data: {
            id: number;
            name: string;
            email: string;
            phone?: string;
            role?: string;
            roles?: string[];
            company_logo?: string | null;
            image?: string | null;
        };
    };
    token: null | string;
}

const initialState: AuthState = {
    me: null,
    token: null,
};

function persistMe(me: AuthState['me']) {
    if (me?.data) {
        try {
            localStorage.setItem(AUTH_ME_KEY, JSON.stringify(me));
        } catch {
            // ignore
        }
    } else {
        try {
            localStorage.removeItem(AUTH_ME_KEY);
        } catch {
            // ignore
        }
    }
}

export function getStoredMe(): AuthState['me'] {
    try {
        const raw = localStorage.getItem(AUTH_ME_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw) as AuthState['me'];
        return parsed?.data ? parsed : null;
    } catch {
        return null;
    }
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state, action: PayloadAction<{ me: AuthState['me']; token: string | null }>) => {
            state.me = action.payload.me;
            state.token = action.payload.token;
            if (action.payload.token) {
                Cookies.set('accessToken', action.payload.token, { expires: COOKIE_EXPIRES_DAYS });
            } else {
                Cookies.remove('accessToken');
            }
            persistMe(action.payload.me);
        },
        logout: (state) => {
            state.me = null;
            state.token = null;
            Cookies.remove('accessToken');
            persistMe(null);
        },
    },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
